import { createContext, useContext, useState } from "react"

type AdminNavContextValue = {
    isOpen: boolean
    open: () => void
    close: () => void
    toggle: () => void
}

const AdminNavContext = createContext<AdminNavContextValue | undefined>(undefined)

export function AdminNavProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false)

    const value = {
        isOpen,
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
        toggle: () => setIsOpen(prev => !prev),
    }

    return (
        <AdminNavContext.Provider value={value}>
            {children}
        </AdminNavContext.Provider>
    )
}

export function useAdminNav() {
    const ctx = useContext(AdminNavContext)
    if (!ctx) {
        return {
            isOpen: false,
            open: () => {},
            close: () => {},
            toggle: () => {},
        }
    }
    return ctx
}


